import _ from "lodash";
import {flatten} from "@/helper/characteristic/Flatten";
import {getChildIdsToLastLevel} from "@/helper/application/characteristic/Provider";
import {search} from "@/helper/characteristic/Search";

export function shorten (characteristics, keyword, searchType)
{
	const matches = [];

	_.forEach(flatten(characteristics), characteristic =>
	{
		if (search(characteristic, keyword, searchType))
		{
			matches.push(characteristic);
		}
	});

	let matchIds = _.map(matches, 'id');

	let shortened = [];

	_.forEach(characteristics, characteristic =>
	{
		const childIdsToLastLevel = getChildIdsToLastLevel(characteristic, characteristics);

		// direct match or any child match
		if (_.includes(matchIds, characteristic.id) || _.intersection(matchIds, childIdsToLastLevel).length > 0)
		{
			shortened.push(characteristic);
		}
	});

	// 202211 deactivated: Decision made (PF/MS/AS) to only shorten first level
	// [now we have to take out all childs which do not match nor does one of their childs match]
	/*_.forEach(shortened, characteristic =>
	{
		shortenCharacteristic(characteristics, characteristic, matchIds);
	});*/

	return shortened;
}

/*function shortenCharacteristic (characteristics, characteristic, matchIds)
{
	characteristic.children = _.filter(
		characteristic.children,
		child =>
		{
			const childIdsToLastLevel = getChildIdsToLastLevel(child, characteristics);

			return _.includes(matchIds, child.id)
				|| _.intersection(matchIds, childIdsToLastLevel).length > 0;
		}
	);

	_.forEach(characteristic.children, child =>
	{
		shortenCharacteristic(characteristics, child, matchIds);
	});
}*/
